import axios from "axios";
import { getHeaders, getURl } from "./core";

let url = `${getURl()}/visa_type/v1`;

export function getMany({ offset = 0, limit = 15, search = "" }) {
   const result = axios({
      method: "GET",
      headers: getHeaders(),
      url: `${url}/lists?offset=${offset}&limit=${limit}&search=${search}`,
   });
   return new Promise((resolve, reject) => {
      result
         .then((response) => resolve(response.data))
         .catch((error) => reject(error));
   });
}

export function getOne(id) {
   const result = axios({
      method: "GET",
      url: `${url}/detail/${id}`,
      headers: getHeaders(),
   });
   return new Promise((resolve, reject) => {
      result
         .then((response) => resolve(response.data))
         .catch((error) => reject(error));
   });
}

export function insertNewRecord(data) {
   return axios({
      method: "POST",
      url: `${url}/create`,
      headers: getHeaders(),
      data,
   });
}

export function updateRecordById(id, dataToUpdate) {
   return axios({
      method: "PUT",
      url: `${url}/update/${id}`,
      headers: getHeaders(),
      data: dataToUpdate,
   });
}

export function softDeleteById(id) {
   return axios({
      method: "DELETE",
      url: `${url}/archive/${id}`,
      headers: getHeaders(),
   });
}
